import { Component, OnDestroy, afterNextRender, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavBar } from './nav-bar/nav-bar';
import { InactivityService } from './services/inactivity.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavBar],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnDestroy {
  private readonly inactivityService = inject(InactivityService);

  constructor() {
    afterNextRender(() => this.inactivityService.start());
  }

  ngOnDestroy(): void {
    this.inactivityService.stop();
  }
}
